import {Injectable} from '@angular/core';
import {AbstractDataServiceDtoAdapter} from '../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {ReportDefinitionModel} from '../../../api/entity/reportDefinition.model';
import {ReportDefinitionConverter} from '../../../api/entity/converter/reportDefinition.converter';
import {ReportDefinitionDataService} from './reportDefinitionData.service';
import {
    AbstractDataServiceDtoSummaryAdapter
} from '../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDtoSummaryAdapter';
import {ReportDefinitionSummaryModel} from '../../../api/entity/reportDefinitionSummary.model';
import {ReportDefinitionSummaryConverter} from '../../../api/entity/converter/reportDefinitionSummary.converter';

@Injectable()
export class ReportDefinitionSummaryDataServiceAdapter
    extends AbstractDataServiceDtoSummaryAdapter<ReportDefinitionSummaryModel, ReportDefinitionSummaryConverter, ReportDefinitionModel> {
    constructor(dataService: ReportDefinitionDataService, converter: ReportDefinitionSummaryConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): ReportDefinitionModel {
        return new ReportDefinitionModel();
    }
}
